import styles from "./ClientHistoryTable.module.scss";

const STATUS_LABELS = {
  pending: "En attente",
  confirmed: "Confirmé",
  completed: "Terminé",
  cancelled: "Annulé",
};

const STATUS_COLORS = {
  pending: "#f0ad4e",
  confirmed: "#5bc0de",
  completed: "#28a745",
  cancelled: "#c0392b",
};

function ClientHistoryTable({ appointments, onSelectAppointment }) {
  if (!appointments || appointments.length === 0) {
    return (
      <div className={styles.emptyState}>
        Aucune prestation enregistrée pour ce client.
      </div>
    );
  }

  return (
    <table className={styles.historyTable}>
      <thead>
        <tr>
          <th>Date</th>
          <th>Prestations</th>
          <th>Montant total</th>
          <th>Statut</th>
        </tr>
      </thead>
      <tbody>
        {appointments.map((appointment) => (
          <tr
            key={appointment.id}
            className={styles.historyRow}
            onClick={() =>
              onSelectAppointment && onSelectAppointment(appointment)
            }
          >
            <td>
              {new Date(appointment.appointment_date).toLocaleDateString(
                "fr-FR",
                { day: "2-digit", month: "2-digit", year: "numeric" },
              )}
            </td>
            <td>
              {appointment.services && appointment.services.length > 0
                ? appointment.services.map((s) => s.name).join(", ")
                : "-"}
            </td>
            <td>
              {appointment.total_amount != null
                ? `${Number(appointment.total_amount).toFixed(2)} €`
                : "-"}
            </td>
            <td>
              <span
                className={styles.statusBadge}
                style={{
                  backgroundColor: STATUS_COLORS[appointment.status] || "#999",
                }}
              >
                {STATUS_LABELS[appointment.status] || appointment.status}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ClientHistoryTable;
